import React from 'react';
import './style.css'; // Import the CSS

const TextSection = () => {
    return (
        <div className="text-section-container">
            <p className="text-section-content">
                Whether you’re looking for reliable vehicles, sustainable waste management solutions, or a partner in progress, 
                Sagar Motors is here to meet your needs. 
                <span className="join-us-highlight"> JOIN US</span> as we continue to drive innovation and create a better tomorrow for all.
            </p>
        </div>
    );
};

export default TextSection;
